import { localDB } from './localDB';

export interface PedidosConfigState {
  sortItemsAlphabetically: boolean;
  sortCategoriesAlphabetically: boolean;
  alwaysShowSelectorModal: boolean;
  enableDoubleClickCourse: boolean;
  autoPrintCancellationComandas: boolean;
  enableQuickBoletaPrint: boolean;
}

export const defaultPedidosConfig: PedidosConfigState = {
  sortItemsAlphabetically: false,
  sortCategoriesAlphabetically: false,
  alwaysShowSelectorModal: false,
  enableDoubleClickCourse: false,
  autoPrintCancellationComandas: false,
  enableQuickBoletaPrint: false,
};

export const loadPedidosConfig = async (): Promise<PedidosConfigState> => {
  const [
    sortItems,
    sortCategories,
    alwaysShowModal,
    enableDoubleClick,
    autoPrintCancellationComandas,
    enableQuickBoletaPrint,
  ] = await Promise.all([
    localDB.get<boolean>('pedidosConfig', 'sortItemsAlphabetically'),
    localDB.get<boolean>('pedidosConfig', 'sortCategoriesAlphabetically'),
    localDB.get<boolean>('pedidosConfig', 'alwaysShowSelectorModal'),
    localDB.get<boolean>('pedidosConfig', 'enableDoubleClickCourse'),
    localDB.get<boolean>('pedidosConfig', 'autoPrintCancellationComandas'),
    localDB.get<boolean>('pedidosConfig', 'enableQuickBoletaPrint'),
  ]);

  return {
    sortItemsAlphabetically: sortItems ?? defaultPedidosConfig.sortItemsAlphabetically,
    sortCategoriesAlphabetically: sortCategories ?? defaultPedidosConfig.sortCategoriesAlphabetically,
    alwaysShowSelectorModal: alwaysShowModal ?? defaultPedidosConfig.alwaysShowSelectorModal,
    enableDoubleClickCourse: enableDoubleClick ?? defaultPedidosConfig.enableDoubleClickCourse,
    autoPrintCancellationComandas: autoPrintCancellationComandas ?? defaultPedidosConfig.autoPrintCancellationComandas,
    enableQuickBoletaPrint: enableQuickBoletaPrint ?? defaultPedidosConfig.enableQuickBoletaPrint,
  };
};

export const setPedidosConfigValue = async (
  key: keyof PedidosConfigState,
  value: boolean
): Promise<void> => {
  await localDB.set('pedidosConfig', key, value);
};

export const resetPedidosConfig = async (): Promise<void> => {
  await Promise.all(
    Object.entries(defaultPedidosConfig).map(([key, value]) =>
      localDB.set('pedidosConfig', key, value)
    )
  );
};

export const getAutoPrintCancellationComandas = async (): Promise<boolean> => {
  const autoPrintCancellationComandas = await localDB.get<boolean>(
    'pedidosConfig',
    'autoPrintCancellationComandas'
  );

  return autoPrintCancellationComandas ?? defaultPedidosConfig.autoPrintCancellationComandas;
};

export const getEnableQuickBoletaPrint = async (): Promise<boolean> => {
  const enableQuickBoletaPrint = await localDB.get<boolean>(
    'pedidosConfig',
    'enableQuickBoletaPrint'
  );

  return enableQuickBoletaPrint ?? defaultPedidosConfig.enableQuickBoletaPrint;
};
